import CoursesSection from './CoursesSection';

export default CoursesSection;
